(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/use-game-engine-hookless.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/use-game-engine-hookless.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const getEngine = svs.racing.gameEngine.getEngine;
const bindActionCreators = (actionCreators, dispatch) => Object.keys(actionCreators).reduce((boundActions, key) => {
  const action = actionCreators[key];
  boundActions[key] = function () {
    return dispatch(action(...arguments));
  };
  return boundActions;
}, {});
const bindSelectors = (selectors, getState) => Object.keys(selectors).reduce((boundSelectors, key) => {
  const selector = selectors[key];
  boundSelectors[key] = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return selector(getState(), ...args);
  };
  return boundSelectors;
}, {});
function useGameEngineHookless(gameType, isSystem, pixMode, race) {
  const engine = getEngine(gameType, isSystem, pixMode);
  let state = engine.reducer({}, engine.actions.initialize(race));
  const getState = () => state;
  const dispatch = action => {
    state = engine.reducer(state, action);
  };
  const actions = bindActionCreators(engine.actions, dispatch);
  const selectors = bindSelectors(engine.selectors, getState);
  return _objectSpread(_objectSpread({}, engine), {}, {
    actions,
    selectors
  });
}
svs.racing.gameEngine.useGameEngineHookless = useGameEngineHookless;

 })(window);